// import models
import * as PATH from '@src/configs/paths'
import { IMenuItem } from '@src/types/menu'
import { isFeatureEnabled } from '@src/utils'

const __MENU_ITEMS = [
    {
        label: 'Swap',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.SWAP,
        _index: 0,
    },
    {
        label: 'Orders',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.ORDERS,
        _index: 1,
    },
    {
        label: 'Rewards',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.REWARDS,
        _index: 3,
    },
    {
        label: 'Developers',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.DEVS,
        _index: 4,
        target: '_blank',
    },
    {
        label: 'Docs',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.DOCS,
        _index: 5,
        target: '_blank',
    },
]

if (isFeatureEnabled('ONRAMP') || isFeatureEnabled('OFFRAMP')) {
    __MENU_ITEMS.push({
        label: 'Fiat Exchange',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.EXCHANGE,
        _index: 2,
    })
}

export const MENU_ITEMS: IMenuItem[] = __MENU_ITEMS.sort((a, b) => a._index - b._index)
